import dayjs from "dayjs";
export default {
  name: "UserInfo",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    createTime: function createTime() {
      var _this$userInfo;
      return (_this$userInfo = this.userInfo) !== null && _this$userInfo !== void 0 && _this$userInfo.createTime ? dayjs.unix(this.userInfo.createTime).format("YYYY-MM-DD") : "";
    }
  }
};